// extracted by mini-css-extract-plugin
export var item = "dc_nf";
export var text = "dc_cL";